import type { IWorkbookInspection, IWorkbookInspectionNamedRange, IWorkbookInspectionWorksheet } from "../../customTypings/spreadsheetTemplate/SpreadsheetTemplate";
import {
    formatInspectionWarningForDisplay,
    getDisplayedInspectionWarnings,
    getHiddenSheetsSummaryText,
    getProtectionSummaryText,
} from "./workbookInspectionDisplay";
import { isBrokenNamedRangeReference } from "./workbookInspectionNamedRange";

export function isSafeToIgnoreNamedRange(range: IWorkbookInspectionNamedRange): boolean {
    return isBrokenNamedRangeReference(range);
}

export function getSafeToIgnoreNamedRanges(inspection: IWorkbookInspection): IWorkbookInspectionNamedRange[] {
    return inspection.namedRanges.filter(isSafeToIgnoreNamedRange);
}

export function getProtectedWorksheets(inspection: IWorkbookInspection): IWorkbookInspectionWorksheet[] {
    return inspection.worksheets.filter((sheet) => sheet.isProtected);
}

export interface WorkbookInspectionPlainEnglishSummary {
    worksheetCount: number;
    namedRangeCount: number;
    dataValidationCount: number;
    safeToIgnoreNamedRanges: IWorkbookInspectionNamedRange[];
    protectionSummaryText: string | null;
    hiddenSheetsSummaryText: string | null;
    reviewWarnings: string[];
}

export function buildWorkbookInspectionPlainEnglishSummary(inspection: IWorkbookInspection): WorkbookInspectionPlainEnglishSummary {
    const safeToIgnoreNamedRanges = getSafeToIgnoreNamedRanges(inspection);
    const reviewWarnings = getDisplayedInspectionWarnings(inspection).map(formatInspectionWarningForDisplay);

    return {
        worksheetCount: inspection.workbook.worksheetCount,
        namedRangeCount: inspection.workbook.namedRangeCount,
        dataValidationCount: inspection.workbook.dataValidationCount,
        safeToIgnoreNamedRanges,
        protectionSummaryText: getProtectionSummaryText(inspection.worksheets),
        hiddenSheetsSummaryText: getHiddenSheetsSummaryText(inspection.worksheets),
        reviewWarnings,
    };
}
